module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.partial.data.title))]), (_vm.partial.data.example) ? _c('p', {
    staticClass: "example"
  }, [_vm._v(_vm._s(_vm.partial.data.example))]) : _vm._e(), _vm._l((_vm.frozenRevisions), function(revision) {
    return _c('div', {
      staticClass: "revision"
    }, [(_vm.progress.isRetaking || _vm.frozenRevisions.length > 1) ? _c('h4', {
      staticClass: "tag revision__title"
    }, [_vm._v(_vm._s(revision.title))]) : _vm._e(), _c('p', {
      staticClass: "revision__container submission submission--answer"
    }, [_vm._v(_vm._s(revision.submission))])])
  }), (!_vm.readonly) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.answer),
      expression: "answer"
    }],
    class: {
      story: _vm.partial.data.story
    },
    domProps: {
      "value": (_vm.answer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.answer = $event.target.value
      }
    }
  }) : _vm._e(), (_vm.readonly && _vm.frozenRevisions.length === 0) ? _c('p', {
    staticClass: "revision__container revision__container--teacher"
  }, [_vm._v("In te vullen door leerling")]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-accb1ac2","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/assignment/partials/QuestionPartial.vue
// module id = VsKO
// module chunks = 1